/**
 * Ensures that essential default data exists in the database.
 * This runs in BOTH demo and real modes, before any seeding.
 *
 * Unlike seeding (which populates demo data), this only ensures
 * the absolute minimum defaults exist for the app to function:
 * - Default report template
 * - Default catalog values (gas types, plant types, etc.)
 *
 * Settings don't need initialization here as they have built-in fallbacks.
 */

import { createDefaultTemplate } from './defaultTemplate';
import { TemplatesRepo } from './repos/templatesRepo';
import { catalogService } from './services/catalogService';

/**
 * Ensure all required default data exists in the database.
 * Safe to call multiple times - will not overwrite existing data.
 */
export async function ensureDefaults(): Promise<void> {
  const defaultTemplate = createDefaultTemplate();

  // Initialize template if not already present
  // TemplatesRepo.initialize checks for existence before inserting
  await TemplatesRepo.initialize(defaultTemplate);
  console.log('[ensureDefaults] Default template initialized');

  // Initialize catalogs with default values if empty
  // catalogService.initializeIfEmpty handles version checks and user modifications
  await catalogService.initializeIfEmpty();
  console.log('[ensureDefaults] Default catalogs initialized');
}
